import type React from "react"
import { getTranslations } from "../../../i18n"
import { useLocale } from "../../../locale-context"
import { JournalRowShell } from "../journal-row-shell"

const UnknownIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<circle cx="8" cy="8" r="1.5" />
	</svg>
)

/**
 * AC7 forward-compat: renders any event whose `type` is not one of the
 * variants the web app knows today. The shape is intentionally loose
 * so a future API event type doesn't break the page-level switch.
 */
export function UnknownEventRow({
	event,
}: {
	event: { id: string; propertyId: string; createdAt: string; type: string }
}) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	return (
		<JournalRowShell
			icon={<UnknownIcon />}
			headline={t.journal.events.unknown.label}
			iso={event.createdAt}
			eventType={event.type}
			aria={t.journal.events.unknown.aria}
		/>
	)
}
